import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { useHiddenFileSelect } from '@paragon/client-tools';
import { enqueueInfo } from '@paragon/notification-tools';

import { processCustomSortFile } from '../../../../store/actions/appActions';
import { getApplicableSortBy } from '../../../../store/selectors/getSortedComponentDesignsSelectors';
import { ComponentSortType, setComponentDesignSortByType } from '../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';

const SUPPORTED_SORT_TYPES = ['name', 'custom'];

export function ComponentSortControl() {
  const dispatch = useAppDispatch();
  const sortBy = useAppSelector(getApplicableSortBy);

  const [renderFileSelect, selectFile] = useHiddenFileSelect('.tps,.seq', false);

  function setComponentSort(type: ComponentSortType | 'custom') {
    if (!SUPPORTED_SORT_TYPES.includes(type)) {
      dispatch(enqueueInfo(`Sorting by ${type} is not yet supported.`));
      return;
    }

    if (type === 'custom') {
      selectFile().then((file) => dispatch(processCustomSortFile(file)));
      return;
    }

    dispatch(setComponentDesignSortByType(type));
  }

  const activeSortBy = Array.isArray(sortBy) ? 'custom' : sortBy;

  return (
    <Box sx={{ margin: 1 }}>
      <FormControl size="small" variant="filled" fullWidth>
        <InputLabel id="sortComponentsBy">Sort By</InputLabel>
        <Select
          labelId="sortComponentsBy"
          value={activeSortBy}
          onChange={(event) => setComponentSort(event.target.value as ComponentSortType)}
        >
          <MenuItem id="sortComponentsByName" value="name">
            Name
          </MenuItem>
          <MenuItem id="sortComponentsByCapacity" value="capacity">
            Capacity
          </MenuItem>
          <MenuItem id="sortComponentByFile" value="custom">
            Custom
          </MenuItem>
        </Select>
      </FormControl>

      {renderFileSelect()}
    </Box>
  );
}
